import { GetProcessChainResponseSchema } from './get-process-chain.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
export const getProcessChainContract = {
    method: 'GET',
    path: '/api/v2/process-chains/:id',
    description: 'Get a process chain with populated process data',
    responseSchema: GetProcessChainResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Chain not found'
        }
    }
};

//# sourceMappingURL=get-process-chain.contract.js.map